"use client";

import { useEffect, useState } from "react";
import { Loader2, Wrench } from "lucide-react";

interface Props {
  text?: string;
}

export function CsLoadingScreen({ text = "Loading website resources..." }: Props) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((p) => {
        if (p >= 82) {
          clearInterval(interval);
          return p;
        }
        return Math.min(p + Math.random() * 14 + 3, 82);
      });
    }, 180);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* CS 1.6 loading dialog — only visible in Freeman/cs16 theme */}
      <div className="hidden cs16:flex fixed inset-0 z-[9999] items-center justify-center" style={{ backgroundColor: "rgba(58, 69, 50, 0.88)" }}>
        <div
          style={{
            fontFamily: "ArialPixel, monospace",
            backgroundColor: "#4a5942",
            border: "1px solid",
            borderColor: "#8c9284 #292c21 #292c21 #8c9284",
            padding: "4px",
            minWidth: "380px",
            maxWidth: "460px",
            color: "#dedfd6",
          }}
        >
          {/* Title bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "3px 2px 6px",
              borderBottom: "1px solid #292c21",
              marginBottom: "2px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <Wrench size={14} color="#8c9284" />
              <span style={{ color: "#fff", fontSize: "16px", lineHeight: "15px" }}>Loading...</span>
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: "10px 10px 4px" }}>
            <p style={{ color: "#a0aa95", fontSize: "15px", lineHeight: "1.2", marginBottom: "10px" }}>{text}</p>

            {/* Progress bar */}
            <div
              style={{
                height: "24px",
                padding: "3px",
                backgroundColor: "#3e4637",
                border: "1px solid",
                borderColor: "#292c21 #8c9284 #8c9284 #292c21",
                marginBottom: "2px",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${progress}%`,
                  backgroundImage: "repeating-linear-gradient(to right, #c4b550 0px, #c4b550 8px, transparent 8px, transparent 12px)",
                  transition: "width 0.18s linear",
                }}
              />
            </div>
          </div>

          {/* Footer */}
          <div style={{ textAlign: "right", padding: "4px 6px 8px" }}>
            <button
              disabled
              style={{
                width: "72px",
                backgroundColor: "#4a5942",
                color: "#dedfd6",
                border: "1px solid",
                borderColor: "#8c9284 #292c21 #292c21 #8c9284",
                padding: "3px 5px",
                fontSize: "15px",
                lineHeight: "15px",
                fontFamily: "ArialPixel, monospace",
                cursor: "default",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      {/* Fallback spinner for light/dark themes */}
      <div className="cs16:hidden flex h-64 items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    </>
  );
}
